import { render } from "./File_FolderPopup.vue?vue&type=template&id=33b367bd&scoped=true"
import script from "./File_FolderPopup.js?vue&type=script&lang=js"
export * from "./File_FolderPopup.js?vue&type=script&lang=js"

import "./File_FolderPopup.vue?vue&type=style&index=0&id=33b367bd&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b367bd"]])

export default __exports__